import React, { useState } from "react";
import { auth } from "../Firebase/FirebaseConfig";
import { signInWithEmailAndPassword } from 'firebase/auth';
import "../styles/LoginForm.css";

const LoginForm = ({ onLogin }) => {
  const [email, setEmail] = useState(""); // Changed 'username' to 'email'
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError("");
    try {
      // Use Firebase authentication to log in
      await signInWithEmailAndPassword(auth, email, password);
      console.log("Logged in successfully");
      // Handle successful login (e.g., redirect or update UI)
    } catch (error) {
      console.error("Error logging in: ", error);
      // Handle errors (e.g., invalid credentials, network issues)
      setError("Failed to log in. Please check your credentials.");
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="login-form">
      <div className="form-group">
        <label htmlFor="email">Email:</label>
        <input
          id="email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          autoComplete="email"
          required
        />
      </div>
      <div className="form-group">
        <label htmlFor="password">Password:</label>
        <input
          id="password"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          autoComplete="current-password"
          required
        />
      </div>
      {error && <div className="error">{error}</div>}
      <button type="submit" disabled={loading}>
        {loading ? "Logging in..." : "Login"}
      </button>
    </form>
  );
};

export default LoginForm;
